module.exports = __webpack_public_path__ + "static/media/(011940).add3570b.jpg";